import * as yup from 'yup';
import type { EntityDropdownConfig } from '../../../services/entity-tree';

export interface AddressFormValues {
  PropertyType: string;
  address: string;
  other: string;
  city: string;
  state: string;
  zipCode: string;
  entity: string;
  entityUUID: string;
}

/**
 * DV-3681: City accepts any characters — the spec says "Validation: None", and real US cities
 * carry periods and accents (St. Louis, Cañon City). It must not be blank or only spaces. Shared by
 * the Add and Edit forms so they cannot drift; import and the API already accept these names.
 */
export const cityValidation = yup
  .string()
  .required('Please enter city')
  .matches(/\S/, 'Please enter city');

/**
 * Yup rules shared by the standalone Add Property form and the slim
 * NewPropertyForm rendered inside the new-order drawer. Keeping these in
 * one file prevents the two consumers from drifting on validation.
 */
export const buildAddressValidationSchema = (
  entityDropdownConfig: Pick<EntityDropdownConfig, 'isRequired'>
) =>
  yup.object().shape({
    PropertyType: yup.string().required('Please select property type'),
    address: yup.string().required('Please enter property address details'),
    other: yup.string(),
    city: cityValidation,
    state: yup
      .string()
      .required('Please select state')
      .matches(/^[a-zA-Z\s]*$/, 'Please enter letters and spaces only'),
    zipCode: yup
      .string()
      .required('Please enter zip code')
      .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, 'Please enter valid zip-code'),
    entity: entityDropdownConfig.isRequired
      ? yup.string().required('Please select an entity')
      : yup.string(),
  });
